export interface ProjectData {
  id: number;
  imageUrl: string;
  title: string;
  description: string;
  date: string;
  tags: string[];
}

export const projectsData: ProjectData[] = [
  {
    id: 13,
    imageUrl: 'metastation.png',
    title: '메타스테이션 x AI도슨트',
    description: '메타스테이션 전시회 AI도슨트와 AI작가 콜라보레이션 프로젝트',
    date: '2024.12',
    tags: ['기획', '개발', '리소스', 'CS운영']
  },
  {
    id: 1,
    imageUrl: '/d.png',
    title: '아프리카TV x 숲 챌린지 ',
    description: '아프리카TV 숲 챌린지 마인크래프트 프로젝트',
    date: '2024.06',
    tags: ['기획', '리소스', 'CS운영', '홈페이지', '개발']
  },
  {
    id: 2,
    imageUrl: 'https://cdn.gametoc.co.kr/news/photo/202411/86134_260923_3917.jpg',
    title: '지스타 X 숲 챌린지',
    description: '지스타 아프리카 숲 챌린지 마인크래프트 프로젝트',
    date: '2024.06',
    tags: ['기획', '리소스', '개발']
  },
  {
    id: 3,
    imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4K2iRfTRKxAevtvGCom-R8i7IHyXYRHWdIA&s',
    title: '라이엇 x 발로란트',
    description: '라이엇 공식 대회 프로그램 개발 프로젝트',
    date: '2024.02',
    tags: ['기획', '리소스', '개발']
  },
  {
    id: 14,
    imageUrl: 'https://funpin.co.kr/pa.png',
    title: '펀핀 자동화',
    description: '펀핀 상품권 충전 자동화 시스템 개발 프로젝트',
    date: '2023.12',
    tags: ['기획', '개발', '리소스', '보안']
  },
  {
    id: 4,
    imageUrl: '/inc.png',
    title: '인천크래프트 스타트업',
    description: '인천시와 함께한 인천크래프트 스타트업 프로젝트',
    date: '2023.11',
    tags: ['기획', '개발', '리소스', '홈페이지', 'CS운영']
  },
  {
    id: 5,
    imageUrl: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*uk5kwYT7P0eldG-ni7emng.jpeg',
    title: '인천 상륙 작전 x 더샌드박스',
    description: '인천시와 함께한 인천크래프트 스타트업 프로젝트',
    date: '2023.10',
    tags: ['기획', '개발', '리소스']
  },
  {
    id: 6,
    imageUrl: 'https://www.sandbox.game/cdn-cgi/image/f=auto,origin-auth=share-publicly,onerror=redirect,w=2560,q=100/https://www.sandbox.game/public-img/experiences/d0af81dd-157e-46e9-addb-7746ce087016/page/pageBanner/19c11ee0751cf17a00707933c7b4d6ef54ac772f38d958df85cf23844990f01a.png',
    title: '스튜디오 드래곤 환혼',
    description: '드라마 환혼을 복셀 형태의 메타버스로 제작 프로젝트',
    date: '2023.10',
    tags: ['기획', '개발', '리소스']
  },
  {
    id: 7,
    imageUrl: 'https://www.yeongnam.com/mnt/file/202309/2023091901000579000023202.jpg',
    title: '메타스테이션 x 디지털 NFT',
    description: '디지털 NFT를 마인크래프트에서 전시하고 판매하는 프로젝트',
    date: '2023.10',
    tags: ['기획', '개발', '리소스', 'CS운영']
  },
  {
    id: 8,
    imageUrl: '/c.png',
    title: 'ZEP x 봉현초등학교 메타버스',
    description: '픽셀 아트로 봉현초등학교 메타버스 구현',
    date: '2023.10',
    tags: ['리소스']
  },
  {
    id: 15,
    imageUrl: 'https://funpin.co.kr/pa.png',
    title: '펀핀 24 상품권 매입',
    description: '펀핀 상품권 상품권 매입 서비스 개발 프로젝트',
    date: '2023.06',
    tags: ['기획', '개발', '리소스', '보안']
  },
  {
    id: 16,
    imageUrl: 'https://pbs.twimg.com/profile_images/1706325735953068032/-LOmVlNK_400x400.jpg',
    title: '달곰즈NFT x 영상제작',
    description: '속초 전광판 달곰즈 NFT 영상 제작 프로젝트',
    date: '2023.02',
    tags: ['기획', '영상', '리소스']
  },
  {
    id: 17,
    imageUrl: 'https://lh5.googleusercontent.com/proxy/rBbipAB-b_fM-QfAwXr3b5VekOPULdI1E8NPx7RsCVWkbAYVuxl6vJffrhCKcagrgPyn-kKV1SHryBI7Itfc8QQ9u1aj1ssrf7QMb6TX8A',
    title: '수창청춘맨숀 x 전시회',
    description: '수창청춘맨숀 NFT 온라인 가상 전시회 기획전2, 3',
    date: '2023.02',
    tags: ['기획', '영상', '리소스']
  },
  {
    id: 9,
    imageUrl: 'https://img.etoday.co.kr/pto_db/2023/01/20230105085424_1837948_1200_1184.jpg',
    title: '두나무x멸종위기 식물 NFT',
    description: '두나무, 멸종 위기 식물 NFT 발행…"판매 수수료 전액 식물보호기금 조성" 프로젝트',
    date: '2023.01',
    tags: ['기획', '리소스']
  },
  {
    id: 16,
    imageUrl: '/usan.png',
    title: '국가유산채널 x 랜드마크',
    description: '각종 플러그인 및 건축, CS 프로젝트',
    date: '2023.01',
    tags: ['기획', '개발', '리소스']
  },
  {
    id: 10,
    imageUrl: 'https://miro.medium.com/v2/resize:fit:2000/1*alC73smlR5GccEBPoKuZrg.png',
    title: '나인크로니클',
    description: 'P2E 게임 나인크로니클을 복셀로 새로운 메타버스 형태의 프로젝트',
    date: '2022.5',
    tags: ['기획', '개발', '리소스']
  },
  {
    id: 11,
    imageUrl: 'https://miro.medium.com/v2/resize:fit:975/1*wX65i-TX02YrtZWOR2NqtQ.png',
    title: '더샌드박스x크리에이터 대한민국',
    description: '20억 투자 프로젝트 진행',
    date: '2019.12',
    tags: ['기획', '개발', '리소스', 'CS운영']
  },
  {
    id: 12,
    imageUrl: 'e.jpg',
    title: '환경부x세컨블럭',
    description: '환경부와 함께하는 환경 메타버스 프로젝트',
    date: '2019.12',
    tags: ['기획', '개발', '리소스', 'CS운영']
  },
]; 